var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2349,
    height: 385,
    viewBox: "0 0 2349 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_1881)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M151.92 100.49H59V45.7402H312.05V100.5H219.13V336.13H151.93V100.49H151.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M402.35 192.17C402.35 105.88 469.55 42 561.23 42C652.91 42 720.11 105.47 720.11 192.17C720.11 278.87 652.49 342.34 561.23 342.34C469.97 342.34 402.35 278.46 402.35 192.17ZM652.08 192.17C652.08 137 613.09 99.25 561.23 99.25C509.37 99.25 470.38 137 470.38 192.17C470.38 247.34 509.37 285.09 561.23 285.09C613.09 285.09 652.08 247.34 652.08 192.17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p1",
    d: "M1062.22 152.35C1062.22 217.07 1013.68 257.31 936.11 257.31H877.62V337.37H810.42V46.9805H936.12C1013.69 46.9805 1062.23 87.2205 1062.23 152.35H1062.22ZM994.19 152.35C994.19 120.41 973.45 101.74 932.38 101.74H877.62V202.55H932.38C973.45 202.55 994.19 183.88 994.19 152.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p2",
    d: "M1404.33 152.35C1404.33 217.07 1355.79 257.31 1278.22 257.31H1219.73V337.37H1152.53V46.9805H1278.23C1355.8 46.9805 1404.34 87.2205 1404.34 152.35H1404.33ZM1336.3 152.35C1336.3 120.41 1315.56 101.74 1274.49 101.74H1219.73V202.55H1274.49C1315.56 202.55 1336.3 183.88 1336.3 152.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1494.63 46.9805H1561.83V337.37H1494.63V46.9805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1918.46 46.9805V337.37H1863.29L1718.51 161.06V337.37H1652.13V46.9805H1707.72L1852.08 223.29V46.9805H1918.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M2223.23 187.61H2284.63V305.42C2252.69 329.48 2208.71 342.34 2167.23 342.34C2075.96 342.34 2008.76 279.7 2008.76 192.17C2008.76 104.64 2075.96 42 2168.47 42C2219.5 42 2261.81 59.42 2290.02 92.19L2246.88 132.02C2225.72 109.62 2201.25 99.25 2171.79 99.25C2115.37 99.25 2076.79 137 2076.79 192.17C2076.79 247.34 2115.37 285.09 2170.96 285.09C2189.21 285.09 2206.22 281.77 2223.23 272.64V187.6V187.61Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_1881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2231.02,
    height: 300.34,
    fill: "white",
    transform: "translate(59 42)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d3ecb5963c172a11f122e624ce519b01.svg";
export { ForwardRef as ReactComponent };